const texts = {
    fin: {
      state: {
        navigation_p1: 'Kartta on navigointi- ja valintatilassa. Voit osoittaa kohteita kartalta:  Sinisellä painikkeella voit tehdä ympyrärajauksen ja haun.',
        selection_pt: 'Rajaa alue kartalta hiirellä osoittaen. Valinnan jälkeen oikealle haetaan rajaukseen osuvat kohteet.',
        navigation_p2: 'Alla rajaukseen osuvat kohteet. Kartta on jälkeen navigointitilassa. Voit myös osoittaa kohteita kartalta: Sinisellä painikkeella voit tehdä ympyrärajauksen ja haun.',
        navigation_p3: 'Rajaus on liian suuri. Tee pienempi/lyhyempi rajaus. Kartta on jälkeen navigointitilassa. Voit myös osoittaa kohteita kartalta. Sinisellä painikkeella voit tehdä uuden rajauksen ja haun.'
      },
      el: {
        bgTypeSelectionTitle:'Tausta-aineistot',
        featTypeSelectionTitle: 'Hakuehdot',
        featurePropertiesTitle: 'Kohteiden tiedot'
      },
      bg: {
        'rasteritaustakartta': 'Karttakuvapalvelu (WMTS) - taustakartta',
        'kiinteisto-avoin': 'Karttakuvapalvelu (Vektoritiilet) - kiinteistöjaotus'
      }
    },
    swe: {
      state: {
        navigation_p1: 'Kartta on navigointi- ja valintatilassa. Voit osoittaa kohteita kartalta tai sinisellä painikkeella hakea kohteita kartalta aluerajauksella.',
        selection_pt: 'Rajaa alue kartalta hiirellä osoittaen. Valinnan jälkeen oikealle haetaan rajaukseen osuvat kohteet.',
        navigation_p2: 'Alla rajaukseen osuvat kohteet. Kartta on jälkeen navigointitilassa. Voit myös osoittaa kohteita kartalta. Sinisellä painikkeella voit tehdä uuden rajauksen ja haun.',
        navigation_p3: 'Rajaus on liian suuri. Tee pienempi/lyhyempi rajaus. Kartta on jälkeen navigointitilassa. Voit myös osoittaa kohteita kartalta. Sinisellä painikkeella voit tehdä uuden rajauksen ja haun.'
      },
      el: {
        bgTypeSelectionTitle:'Tausta-aineistot',
        featTypeSelectionTitle: 'Hakuehdot',
        featurePropertiesTitle: 'Kohteiden tiedot'
      },
      bg: {
        'rasteritaustakartta': 'Karttakuvapalvelu (WMTS) - taustakartta',
        'kiinteisto-avoin': 'Karttakuvapalvelu (Vektoritiilet) - kiinteistöjaotus'
      }
  
    },
    eng: {
      state: {
        navigation_p1: 'Map is in navigation and select mode. You may select features by clicking or drag and select with the blue button.',
        selection_pt: 'Point with mouse to reverse geocode features. Features are fetched aftermouse button is released.',
        navigation_p2: 'Features below. Map is back in navigation mode. Click on the map or use the blue button to drag and select',
        navigation_p3: 'Filter is too large. Reduce area or length. Map is back in navigation mode. Click on the map or use the blue button to drag and select'
      },
      el: {
        bgTypeSelectionTitle:'Background layers',
        featTypeSelectionTitle: 'Feature Type options',
        featurePropertiesTitle: 'Feature Properties'
      },
      bg: {
        'rasteritaustakartta': 'Karttakuvapalvelu (WMTS) - background map',
        'kiinteisto-avoin': 'Karttakuvapalvelu (Vektoritiilet) - cadastre boundaries'
      }
    }
  
  };

  function applyLocale(locale){
    for (const [key, value] of Object.entries(locale.el)) {
        const localisedEl = document.getElementById(key);
        if (!localisedEl) {
          continue;
        }
        localisedEl.innerText = value;
      }
      
  }

  function getLocalizationGroup(locale,group) {
    return locale[group];
  }

const  webLang = {
    fi: 'fi',
    fin: 'fi',
    'fi-FI': 'fi',
    sv: 'sv',
    swe: 'sv',
    'sv-FI': 'sv',
    en: 'en',
    eng: 'en'
  },

  normalizedLang = {
    fi: 'fin',
    fin: 'fin',
    'fi-FI': 'fin',
    sv: 'swe',
    swe: 'swe',
    'sv-FI': 'swe',
    en: 'eng',
    eng: 'eng'
  };

  export { texts, applyLocale, webLang, normalizedLang, getLocalizationGroup } ;